import { render, staticRenderFns } from "./BuySectionUspDrawer.vue?vue&type=template&id=6147ffda&scoped=true&"
import script from "./BuySectionUspDrawer.vue?vue&type=script&lang=ts&"
export * from "./BuySectionUspDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./BuySectionUspDrawer.vue?vue&type=style&index=0&id=6147ffda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6147ffda",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsMarkdownRender: require('/var/www/packages/theme/components/atoms/MarkdownRender.vue').default,AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default,AtomsKEDrawer: require('/var/www/packages/theme/components/atoms/KEDrawer.vue').default})
